import API from '@/services/api';

// Actions
export const FETCH_ROLES = 'fetchRoles';
export const FETCH_ROLE = 'fetchRole';
export const CREATE_ROLE = 'createRole';
export const UPDATE_ROLE = 'updateRole';
export const DELETE_ROLE = 'deleteRole';

// Mutations
export const STORE_SET_ROLES = 'storeSetRoles';
export const STORE_ADD_ROLE = 'storeAddRole';
export const STORE_UPDATE_ROLE = 'storeUpdateRole';
export const STORE_DELETE_ROLE = 'storeDeleteRole';

const state = {
    roles: []
};

const getters = {
    roles(state) {
        return state.roles;
    }
};

const actions = {
    [FETCH_ROLES](context) {
        return new Promise((resolve, reject) => {
            API
                .query('roles')
                .then((response) => {
                    context.commit(STORE_SET_ROLES, response.data);
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response);
                });
        });
    },
    [FETCH_ROLE](context, role) {
        return new Promise((resolve, reject) => {
            API
                .query('roles/' + role)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(({response}) => {
                    reject(response.data);
                });
        });
    },
    [CREATE_ROLE](context, role) {
        return new Promise((resolve, reject) => {
            API
                .post('roles', role)
                .then((response) => {
                    context.commit(STORE_ADD_ROLE, response.data);
                    resolve(response.data);
                })
                .catch(({response}) => {
                    reject(response.data);
                });
        });
    },
    [UPDATE_ROLE](context, object) {
        return new Promise((resolve, reject) => {
            API
                .update('roles', object.id, object.changes)
                .then((response) => {
                    context.commit(STORE_UPDATE_ROLE, response.data);
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response);
                });
        });
    },
    [DELETE_ROLE](context, role) {
        return new Promise((resolve, reject) => {
            API
                .delete('roles/' + role.id)
                .then((response) => {
                    context.commit(STORE_DELETE_ROLE, role);
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response)
                });
        });
    }
};

const mutations = {
    [STORE_SET_ROLES](state, roles) {
        state.roles = roles;
    },
    [STORE_ADD_ROLE](state, role) {
        state.roles.push(role);
    },
    [STORE_UPDATE_ROLE](state, role) {
        let roles = [];

        state.roles.map((mapUser) => {
            if (mapUser.id === role.id) {
                mapUser = role;
            }

            roles.push(mapUser);
        });

        state.roles = roles;
    },
    [STORE_DELETE_ROLE](state, role) {
        state.roles.splice( state.roles.indexOf(role), 1 );
    }
};

export default {state, getters, actions, mutations}